import { useEffect } from "react";
import { autoSubtypeForPreset, useGridStore } from "../store/gridStore";

/**
 * Cambia el subtype de cada celda automaticamente segun el preset.
 *  - preset <= 4 -> main (0)
 *  - preset 9    -> sub (1)
 *  - preset >= 16 -> sub (1)
 * El usuario puede forzar con manualSubtype y eso prevalece.
 *
 * Reacciona a cambios de preset O a celdas nuevas (asignaciones) para que
 * el subtype quede correcto sin importar el orden de las acciones.
 */
export function useAutoSubtype() {
  const preset = useGridStore((s) => s.preset);
  const cells = useGridStore((s) => s.cells);
  const setSubtype = useGridStore((s) => s.setSubtype);

  useEffect(() => {
    const target = autoSubtypeForPreset(preset);
    cells.forEach((c) => {
      if (c.manualSubtype !== null) return;
      if (c.subtype !== target) setSubtype(c.cellId, target);
    });
  }, [preset, cells, setSubtype]);
}
